import { SearchOutlined } from "@ant-design/icons";
import { Breadcrumb, Card, Flex, Input, Row, Space } from "antd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";

const AllNewsList = ({
    allNewsList = () => { }
}) => {
    const { t } = useTranslation();

    return (
        <MainLayout>
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("news.header"), href: "" },
                        { title: t("news_list.header") }
                    ]} />
                    <h2>{t("news_list.header")}</h2>
                </Flex>
                <Card style={{ borderRadius: "20px" }}>
                    <Row>
                        <Input placeholder="search" allowClear style={{ width: "15%", borderRadius: "24px", height: "100%" }} prefix={<SearchOutlined />} />
                    </Row>
                    {allNewsList()}
                </Card>
            </Space>
        </MainLayout>
    );
};

export default AllNewsList;